var common = require("../../utiles/common.js")
var service = require("../../utiles/service")
module.exports = {
    register: function () {
        document.createElement('track-item')
        ko.components.register('track-item', {
            viewModel: function (params) {
                var $this = this;
                var pageIndex = 1;
                $this.isNumber = ko.observable(true);
                $this.records = ko.observable('');
                $this.isViold = ko.observable(false);
                $this.userId = sessionStorage.getItem('currentId');//service.user.getUser().id;
                
                $this.getList = function(index){
                    if(!$this.isNumber()&&!index)return false;
                    $this.isNumber(false)
                    var start = new Date($("#startTime").val());
                    var end = new Date($("#endTime").val());
                    if(start.getTime()>end.getTime()){
                        $this.isViold(true);
                        return false;
                    }else{
                        $this.isViold(false);
                    }
                    if(!index){
                        pageIndex++;
                    }else{
                        pageIndex=1;
                    }
                    var param={
                        pageSize:10,
                        pageNumber:index?index:pageIndex,
                        startDate:start.getTime(),
                        endDate:end.getTime()
                    }
                    console.log("pageIndex----------"+pageIndex)
                    var log = service.logs.loginLog(param).data;
                    $this.isNumber(true);
                    $(".zxf_pagediv").createPage({
                        total:log.totalNumber,
                        pageNum: log.totalPage,
                        current: log.pageNumber,
                        backfun: function(e) {
                            param.pageNumber = e.current;
                            log = service.logs.loginLog(param).data;
                            $this.records(log.logs);
                        }
                    });
                    if(log.logs&&log.logs.length<10){
                        $this.isNumber(false)
                    }
                    $this.records(log.logs);
                }
                $this.scrollBottomTest = function(){
                    $("#track").scroll(function(){
                        var self=$(this),
                        viewH =self.height(),
                        contentH =self.get(0).scrollHeight,
                        scrollTop =self.scrollTop();
                        if(contentH - viewH - scrollTop < 100) {
                            if($this.isNumber()){
                                $this.getList();
                            }
                        }
                    });
                }
                laydate.render({
                    elem: '#startTime'
                    ,type: 'datetime'
                  });
                  laydate.render({
                    elem: '#endTime'
                    ,type: 'datetime'
                  });
                $this.byTime = function(){
                    var start = new Date($("#startTime").val());
                    var end = new Date($("#endTime").val());
                    if(start.getTime()>end.getTime()){
                        $this.isViold(true);
                        return false;
                    }else{
                        $this.isViold(false);
                    }
                }
            },
            template: require("./Track.html")
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/component/track/Track.js
// module id = 139
// module chunks = 0